"use client";
import React from "react";
import BackBtn from "./BackBtn3";
const HeroPage3: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <div className=" bg-cover bg-[linear-gradient(90deg,rgba(var(--primary-color-rgb),0.2)_0%,rgba(var(--primary-color-rgb),0.2)_100%),url('/images/hero-3-image.webp')]">
      <div
        className={`wrapper relative py-[7rem] text-white  flex md:flex-col justify-between ${className} `}
      >
        <span className="absolute top-10 left-0">
          <BackBtn />
        </span>
        {children && <div className="w-full">{children}</div>}
      </div>
    </div>
  );
};
export default HeroPage3;
